












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";
import appointComp from '@/views/home/components/Appoint.vue'
import appointDialog from '@/components/dialog/appoint/index'
@Component<VBANNER>({
  components: {
    dialogComp,
    appointComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public uname:string = '';
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  
  public goUrl() {
    location.href =
      "https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong";
  }

  public submitAppointCallback(){
    this.close();
  }
}
